<template lang="pug">
    .oauth-popup-result
        p {{ $t('Connection completed. You can close this window.') }}
</template>

<i18n>
{
    "de": {
        "Connection completed. You can close this window.": "Verbindung abgeschlossen. Du kannst dieses Fenster schließen."
    }
}
</i18n>

<script>
/**
 * Bridge page for the mailbox OAuth popup. The API's OAuth callback redirects
 * here with the result in the URL FRAGMENT (never sent to any server, never in
 * access logs): #status=connected&token=<nonce>&email=<address>. This page posts
 * the result to the opener (the SmtpCredentials form) and closes itself — the
 * API renders no views for this anymore (views on the API are for emails/PDFs).
 */
export default {
    name: 'OAuthPopupResult',
    mounted() {
        const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))

        if (window.opener && !window.opener.closed) {
            window.opener.postMessage({
                source: 'communication-oauth',
                status: params.get('status') || 'error',
                token: params.get('token') || null,
                email: params.get('email') || null
            }, window.location.origin)
        }

        // Give the opener a moment to receive the message, then close.
        setTimeout(() => window.close(), 150)
    }
}
</script>

<style lang="sass" scoped>
.oauth-popup-result
    display: flex
    align-items: center
    justify-content: center
    min-height: 60vh
    color: #909399
</style>
